module.exports = __webpack_public_path__ + "static/private-cloudfront-config-3-3f482563ecc604152d7c506578fd735a.png";